<template>
    <div class="container box-like">
        <div class="button-box">
            <a-space size="large">
                <a-button icon="plus" type="primary" @click="onAdd">新建订单</a-button>
                <a-space>
                    <strong>已审核</strong>
                    <a>{{statData.yshenhecount}}</a>
                    <strong>未审核</strong>
                    <a>{{statData.wshenconunt}}</a>
                    <strong>复审</strong>
                    <a>{{statData.fscount}}</a>
                </a-space>
            </a-space>
            <a-button icon="retweet" @click="onFilterAllReset" style="margin-left: 8px">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 1500, y: 76 * 8 }"
            :pagination="pageConfig">
            <!-- slot对应配置文件中customRender的内容 -->
            <div slot="c-detail" slot-scope="text, record">
                <a-popover title="订单详情">
                    <template slot="content">
                        <table border="1" cellpadding="6" style="text-align: center; margin-bottom: 6px;">
                            <tr>
                                <th>商品类型</th>
                                <th>商品规格</th>
                                <th>总数量</th>
                                <th>总重量</th>
                                <th>总价</th>
                                <th>备注</th>
                            </tr>
                            <tr v-for="(item, index) in text" :key="index">
                                <td>{{item.goodsname}}</td>
                                <td>{{item.specification}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.weight}}</td>
                                <td>{{item.money}}</td>
                                <td>{{item.remark}}</td>
                            </tr>
                        </table>
                        <a type="primary" @click="onPrintOrder(record)">点击打印此订单</a>
                    </template>
                    <a>点击查看详情</a>
                </a-popover>
            </div>
            <div slot="c-type" slot-scope="text">
                <a-switch :checked="Boolean(2 - text)" disabled />
            </div>
            <div slot="c-money" slot-scope="text, record" style="display: flex; justify-content: center;">
                <div>{{text || record.summoney}}</div>
                <a-popover title="修改实付金额" trigger="click" v-model="showModifyPrice[record.id]">
                    <template slot="content">
                      <a-input type="number" placeholder="请输入实付金额" style="width: 150px;" v-model="modifiedPrice" />
                      <a-button type="primary" style="margin-left: 10px;" @click="submitModifiedPrice(record.id)">提交</a-button>
                    </template>
                    <a-icon type="edit" style="margin-left: 4px; margin-top: 2px; color: #108ee9;" />
                </a-popover>
            </div>
            <div slot="c-action" slot-scope="text, record" style="display: flex; justify-content: center;">
                <a-tooltip placement="bottom" v-if="record.is_pay === 1">
                    <template slot="title">
                        <span>该订单已支付，不可修改</span>
                    </template>
                    <a-button type="primary" style="margin-right: 4px;">收费</a-button>
                    <a-button type="danger">退回</a-button>
                </a-tooltip>
                <div v-if="record.is_pay === 2">
                    <a-button type="primary" style="margin-right: 4px;" @click="onEdit(record)">收费</a-button>
                    <a-button type="danger" @click="onReturn(record.id)">退回</a-button>
                </div>
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''"
                    v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <a-range-picker class="filter-range" valueFormat="YYYY-MM-DD" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'range'" />
                <div class="filter-button">
                    <a-button type="primary" icon="search" size="small" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button icon="retweet" size="small" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>

        <edit-drawer :show="showDrawer" :oid="selectedId" @print="(e) => onPrintOrder(e)" @close="() => {showDrawer = false; onInit()}"></edit-drawer>
        <edit-print v-if="showPrint" :oid="printId" :printCount="printCount" @finish="() => showPrint = false"></edit-print>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap,
    payment
} from '@/common/project-config'
import {
    columns
} from './edit.conf.js'
import editDrawer from './edit.drawer'
import editPrint from './edit.print'

export default {
    name: 'order_edit',
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    components: {
        editDrawer,
        editPrint
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 表格数据
            tableData: [],
            // 统计数据
            statData: {},
            // 修改的实付金额
            modifiedPrice: "",
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 表格配置，在配置文件里
            columns: [...columns],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 8,
                total: 0,
                pageSizeOptions: ['8', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 显示抽屉
            showDrawer: false,
            // 显示打印界面
            showPrint: false,
            // 显示修改实付金额弹窗
            showModifyPrice: {},
            // 打印id
            printId: -1,
            // 打印份数
            printCount: 1
        }
    },
    created() {

    },
    mounted() {
        this.onInit(true)
    },
    activated() {
        this.showPrint = false
    },
    props: {

    },
    watch: {
        showModifyPrice: {
            handler(oldVal, newVal) {
                if (Object.values(newVal).every((item) => !item)) {
                    this.modifiedPrice = ""
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit(reMap) {
            // 开始loading
            this.setLoading('页面加载中...')
            if (reMap) {
                await this.initMap()
            }
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.order.get, {
                status: this.userInfo.stationId,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                is_type: 1,
                uid: this.userInfo.uid,
                ...this.filterItems,
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s}
                _s.status = stationMap[_s.status]
                this.$set(this.showModifyPrice, _s.id, false)
                return _s
            })
            // 其它的逻辑写在这里
            this.pageConfig.total = res.data.total
            this.initStatData()
            // 结束loading
            this.setLoading('')
        },
        async initStatData() {
            let res = await this.$util.request(this.$ctrl.order.statData, {
                status: this.userInfo.stationId
            })
            this.statData = res
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 区域管理
            // res = await this.$util.request(this.$ctrl.area.get, {
            //     status: this.userInfo.stationId,
            // })
            // index = this.columns.findIndex((s) => s.filterIndex === 'area_id')
            // this.columns[index].items = res.data.data
            // 支付方式
            index = this.columns.findIndex((s) => s.filterIndex === 'pay')
            this.columns[index].items = Object.entries(payment).reduce((p, [k, v]) => [
                ...p, {
                    id: k,
                    name: v
                }
            ], [])
            // // 客户类型
            // res = await this.$util.request(this.$ctrl.guest_type.get, {
            //     status: this.userInfo.stationId,
            // })
            // index = this.columns.findIndex((s) => s.dataIndex === 'typename')
            // this.columns[index].items = this.formModel.ctyid.items = res.data.data
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = ''
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onAdd() {
            this.selectedId = -1
            this.showDrawer = true
        },
        onEdit(e) {
            this.selectedId = e.id
            this.showDrawer = true
        },
        onReturn(e) {
            this.$confirm({
                title: '提示',
                content: '确定要退回吗？',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.order.returns, {
                        id: e
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '退回成功',
                                centered: true
                            })
                            if (this.tableData.length <= 1 && this.pageConfig.current > 1) {
                                this.pageConfig.current -= 1
                            }
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '退回失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        onPrintOrder(e) {
            this.printId = e.id
            this.printCount = e.printCount || 1
            this.showPrint = true
        },
        submitModifiedPrice(id) {
            const price = this.modifiedPrice
            if (price) {
                this.showModifyPrice[id] = false;
                this.$confirm({
                    title: '提示',
                    content: `确定要将实付金额改为 ${price} 吗？`,
                    okText: '确定',
                    cancelText: '取消',
                    okType: 'danger',
                    centered: true,
                    onOk: () => {
                        this.$util.request(this.$ctrl.order.modifyPrice, {
                            id,
                            summoney: price
                        }).then((res) => {
                            if (res.code === 1) {
                                this.onInit()
                            }
                        })
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
    @import './edit.less';
</style>
